export enum FieldType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
  FILE = 'FILE',
  LOCATION = 'LOCATION',
  SECTION = 'TITLE_DIVIDER',
}
